import React, { useContext, useMemo } from 'react';
import {
    IOrgLevel1, OrgLevel1, IEntityFormValidations, EntityFormValidations,
    IEntityValidations, EntityValidations, ISpecificEntityFormProps
} from '../../types';
import { LookupService } from '../../services';
import styles from '../../styles/cr.module.scss';
import { CrUserPicker } from '../cr/CrUserPicker';
import { CrTextField } from '../cr/CrTextField';
import { CrDropdown } from '../cr/CrDropdown';
import { EntityForm } from '../EntityForm';
import { DataContext } from '../DataContext';
import { IntegrationContext } from '../IntegrationContext';
import { OrbUserContext } from '../OrbUserContext';

export const GroupForm = (props: ISpecificEntityFormProps): React.ReactElement => {
    const { userPermissions, orbConfig } = useContext(OrbUserContext);
    const { disableGroupManagement } = useContext(IntegrationContext);
    const { dataServices, lookupData, loadLookupData: { entityStatuses, users: { all: allUsers } } } = useContext(DataContext);

    useMemo(() => entityStatuses(), [entityStatuses]);
    useMemo(() => allUsers(), [allUsers]);

    const validateEntity = (group: IOrgLevel1): Promise<IEntityFormValidations> => {
        const errors = new EntityFormValidations();

        if (group.Title === null || group.Title === '') {
            errors.Title = `${orbConfig.OrgL1Label} name is required`;
            errors.Valid = false;
        }
        else
            errors.Title = null;

        return Promise.resolve(errors);
    };

    return (
        <EntityForm<IOrgLevel1, IEntityValidations>
            {...props}
            entityName={orbConfig.OrgL1Label}
            renderFormFields={(changeHandlers, formState) => {
                const { FormData: group, ValidationErrors: errors } = formState;
                return (
                    <div>
                        <CrTextField
                            label="Name"
                            maxLength={50}
                            className={styles.formField}
                            required={true}
                            disabled={disableGroupManagement || !userPermissions.UserIsSystemAdmin()}
                            value={group.Title}
                            onChange={(ev, newValue) => changeHandlers.changeTextField(newValue, 'Title')}
                            errorMessage={errors.Title} />
                        <CrUserPicker
                            label={orbConfig.OrgMgrL1Lable}
                            className={styles.formField}
                            users={lookupData.Users?.All}
                            selectedUsers={group.DirectorGeneralUserID && [group.DirectorGeneralUserID]}
                            onChange={v => changeHandlers.changeUserPicker(v, 'DirectorGeneralUserID')} />
                        <CrUserPicker
                            label="Deputy Director risk champion"
                            className={styles.formField}
                            users={lookupData.Users?.All}
                            selectedUsers={group.RiskChampionDeputyDirectorUserID && [group.RiskChampionDeputyDirectorUserID]}
                            onChange={v => changeHandlers.changeUserPicker(v, 'RiskChampionDeputyDirectorUserID')} />
                        <CrUserPicker
                            label="Portfolio Office business partner"
                            className={styles.formField}
                            users={lookupData.Users?.All}
                            selectedUsers={group.BusinessPartnerUserID && [group.BusinessPartnerUserID]}
                            onChange={v => changeHandlers.changeUserPicker(v, 'BusinessPartnerUserID')} />
                        <CrDropdown
                            label="Status"
                            className={styles.formField}
                            disabled={disableGroupManagement}
                            options={LookupService.entitiesToSelectableOptions(lookupData.EntityStatuses)}
                            selectedKey={group.EntityStatusID}
                            onChange={(_, o) => changeHandlers.changeStatusDropdown(o, 'EntityStatusID')} />
                    </div>
                );
            }}
            loadEntity={id => dataServices.orgLevel1Service.read(id, true, true)}
            loadNewEntity={() => new OrgLevel1()}
            loadEntityValidations={() => new EntityValidations()}
            onValidateEntity={validateEntity}
            onCreate={g => dataServices.orgLevel1Service.create(g)}
            onUpdate={g => dataServices.orgLevel1Service.update(g.ID, g)}
        />
    );
};
